import React from 'react';
import { Query } from 'react-apollo';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';
import Propagator from '../../Propagator';
import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';
import { GAME, BUSINESSPLAN } from '../../routes';
import TransformVariables from '../TransformVariables';
import gql from 'graphql-tag';

const GAME_QUERY = gql`
	query($gameID: ID!) {
    showSubmissionPopup @client
		loading @client
		user {
			id
			game(gameID: $gameID){
				id
				status
				scenario {
					id
					name
				}
				data
      }
		}
	}
`;

const GameQuery = ({ children }) => (
	<Switch>
		<Route
			path={BUSINESSPLAN}
			render={(props) => <Game {...props} fatherChildren={children}/>}
		/>
		<Route
			path={GAME}
			render={(props) => <Game {...props} fatherChildren={children}/>}
		/>
	</Switch>
);

export default GameQuery;

function Game({ match, fatherChildren }) {
	return (
		<Query
			query={GAME_QUERY}
			variables={{ gameID: match.params.gameID }}
		>
			{queryState => {
				return Propagator(
					fatherChildren,
					queryState,
					childProps => {
						if (!childProps.data.user) {
							console.log(childProps.data)
						}
						const {game} = childProps.data.user;
						const gameData = cloneDeep(game.data);
						const currentBusinessPlan = find( gameData.businessPlans, { submission : gameData.lastSubmission });
						const businessPlan = cloneDeep(match.params.businessPlanID
							? find( gameData.businessPlans, { submission : parseInt(match.params.businessPlanID) })
							: currentBusinessPlan)
						businessPlan.variables = TransformVariables(businessPlan.variables);
						for ( let businessPlanItem of gameData.businessPlans ) {
							businessPlanItem.variables = TransformVariables(businessPlanItem.variables);
						}
						return {
							game: {
								id: game.id,
								status: game.status,
								scenario: game.scenario,
								...gameData,
								businessPlan,
								...businessPlan.variables,
								currentBusinessPlan,
								showSubmissionPopup: childProps.data.showSubmissionPopup,
								loading: childProps.data.loading
							},
							loading: queryState.loading,
							error: queryState.error
						};
					},
					childProps => !childProps.data || !childProps.data.user
				);
			}}
		</Query>
	);
}
